import {post} from '../utils'

export default host => data => post(`${host}/purchases/import`, JSON.stringify(data))